import React from "react"
import { GlobalContext } from '../../../contexts/GlobalContext';

import ProductThumbnail from './ProductThumbnail';
import ProductPrice from './ProductPrice';
import ProductTitle from './ProductTitle';
import ProductAddToCart from '../Product/ProductAddToCart';

import theme from '../../../config/theme';
import ProductTag from './ProductTag';
import Link from '../Base/Link';
import CardRarityBadge from "./CardRarityBadge";
import CardSetBadge from "./CardSetBadge";

const Product = (props) => {

    //Adjustment for typesense's stupid handling of ids
    props.product.id = parseInt(props.product.id);

    return (
        <div className={`product`}>
            <style jsx>{`
                .product {
                    display: flex;
                    width: 100%;
                    min-width: 100%;
                    padding: 15px;
                    margin: 5px;
                    box-sizing: border-box;
                    flex-direction: column;
                    cursor: pointer;

                    max-width: ${props.variant === 'showcase' ? 600 : 300}px;
                    border-radius: 2px;
                    transition: all 0.1s ease-in;
                    border-radius: 10px;
                }



                .out-of-stock {
                    filter: grayscale(100%) brightness(99%);
                }

                .product-element {
                    background-color: ${theme.colors.base.white};
                    display: flex;

                    ${props.variant === 'showcase' ? `
                        flex-direction: row;
                    ` : `
                        flex-direction: column;
                    `}

                }

                .product-data {
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    ${props.variant === 'showcase' ? 'height: 327px;' : ''}
                    justify-content: space-evenly;
                }

                .product:first-of-type {
                    margin-left: 0px;
                }

                .product:last-of-type {
                    margin-right: 0px;
                }

                .product .product-price {
                    flex-grow: 1;
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;
                }

                .product .description {
                    width: 100%;
                    text-align: justify;


                    padding-right: 15px;
                    box-sizing: border-box;
                    font-size: 14px;
                    height: 185px;
                    text-overflow: ellipsis "...";
                    overflow: hidden;
                }

                .thumbnail {
                    width: ${props.variant === 'showcase' ? '100%' : '100%'};
                    min-width: ${props.variant === 'showcase' ? 252 : 150}px;
                    height:${props.variant === 'showcase' ? 330 : 220}px;
                    border-bottom: 0;
                    box-sizing: border-box;
                    position: relative;
                    transition: all 0.1s;

                    display: flex;
                    justify-content: center;
                }

                @media only screen and (max-width: ${theme.responsive.m}px) {
                    .product-element {
                        align-items: center;
                    }
                    .product {
                        padding: 4px;
                        margin: 0;
                        align-items: center;
                    }


                    .description {
                        height: 130px!important;
                    }

                    .thumbnail {
                        min-width: ${props.variant === 'showcase' ? '200px' : '130px'};
                        height: ${props.variant === 'showcase' ? '160px' : '160px'};
                    }

                    .product-data {
                        ${props.variant === 'showcase' ? 'height: 265px;' : ''}

                    }
                }

                @media only screen and (min-width: ${theme.responsive.s}px) {
                    .product-data {
                        margin-left: ${props.variant === 'showcase' ? '10px' : '0'};
                    }

                }

                @media only screen and (max-width: ${theme.responsive.s}px) {
                    .product-element {
                        flex-direction: column;
                    }

                    .product-data {
                        height: auto;
                    }

                    .description {
                        display: none;
                    }
                }

                .in-cart-combo {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content:center;
                    width: 36px;
                    height: 36px;
                    opacity: 0.9;
                    font-weight: 900;
                }

                .in-cart-number {
                    font-size: 14px;
                    margin-right: 3px;
                    text-align: center;

                }

                .in-cart-icon {
                    margin-top: -5px;
                    opacity: 0.8;
                }

                .badge {
                    font-size: 12px;
                    font-weight: bold;
                    background-color: #EAEAEA;
                    color: #444444;
                    border-radius: 4px;
                    padding: 2px 4px;
                    margin: 0px 4px;
                }

                .badges {
                    justify-content: center;
                    display: flex;
                    margin-top: 10px;
                }

                .thumbnail-image {
                    width: 100%;
                    height: 100%;
                }


            `}

            </style>
            <>
                <Link as={`/single/${props.product.id}`} href={`/single/[id]`}>
                    <div className={`product-element
                        ${props.product.quantity > 0 ? '' : props.product.preorderQuantity > 0 ?
                            ' preorder' : ''}`}

                    >
                        <div className={`thumbnail`}>
                            <div className={`thumbnail-image ${props.product.quantity === 0 ? 'out-of-stock' : ''}`}>
                                <ProductThumbnail priority={props.priority} product={props.product} />
                            </div>
                            <ProductTag bottom={true} left={true} variant="rarity" round={true}>
                                <CardRarityBadge rarity={props.product.rarity} variantName={props.product.variantName}/>
                            </ProductTag>
                        </div>


                        <div className="product-data">
                            <div className="title">
                                <ProductTitle variant={props.variant}>
                                    {props.product.name}
                                </ProductTitle>
                                <div className="badges">
                                    <CardSetBadge product={props.product} full/>
                                </div>
                            </div>

                            <div className="product-price">
                                <ProductPrice product={props.product} />
                            </div>

                        </div>
                    </div>
                </Link>
                <GlobalContext.Consumer>
                    {(GlobalContext) => {
                        const isProductInCart = GlobalContext.isInCart(props.product.id, 'card');

                        return (
                            props.showAddToCart !== false ?
                                <ProductAddToCart
                                    inCart={isProductInCart}
                                    loading={GlobalContext.globalCartLoading(props.product.id, 'card')} forceAdd={props.product.quantity > 0 || props.product.preorderQuantity > 0} product={props.product}
                                    canAdd={props.product.quantity > GlobalContext.isInCart(props.product.id, 'card') || props.product.preorderQuantity > GlobalContext.isInCart(props.product.id, 'card')}
                                    onClick={() => {
                                        if (props.product.quantity > GlobalContext.isInCart(props.product.id, 'card') || props.product.preorderQuantity > GlobalContext.isInCart(props.product.id, 'card')) {
                                            GlobalContext.addToCart(props.product, 'card')
                                        }
                                    }} /> : null
                        )
                    }}
                </GlobalContext.Consumer>

            </>
        </div>
    )
}

export default Product;
